import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import Main from './components/Main';

const CleanKindManagement = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="清潔類別設定及管理"
          breadcrumbs={[
            {
              name: '清潔打掃',
            },
            {
              name: '清潔類別設定及管理',
            },
          ]}
        />
        <Main />
      </Col>
    </Row>
  );
};

export default CleanKindManagement;
